<div
  class="transfer-visualization"
  *ngIf="shouldShow()">
  <div class="facility-pair">
    <div class="facility-card accent-red">
      <div class="label">FACILITY</div>
      <div class="name">{{ formatFacilityName(sourceFacility!.name) }}</div>
      <div class="patient-id">
        PATIENT ID: <span>{{ sourceFacility!.patientId }}</span>
      </div>
    </div>

    <div class="arrow-animation">
      <div class="arrow">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div
      class="facility-card accent-blue"
      *ngIf="destinationFacility">
      <div class="card-header">
        <div class="label">FACILITY</div>
        <button
          *ngIf="allowEdit"
          class="edit-button"
          type="button"
          (click)="onEditDestinationFacility()"
          mat-icon-button
          [attr.aria-label]="'Edit target facility'">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      <div class="name">{{ formatFacilityName(destinationFacility.name) }}</div>
      <div class="patient-id">
        PATIENT ID: <span>{{ destinationFacility.patientId }}</span>
      </div>
    </div>
  </div>

  <div
    class="facilitator-info"
    *ngIf="allFacilitators && allFacilitators.length > 0">
    <div class="facilitator-header">
      <div class="label">FACILITY USER{{ allFacilitators.length > 1 ? 'S' : '' }}:</div>
      <button
        *ngIf="allowEdit"
        class="edit-button"
        type="button"
        (click)="onEditFacilitators()"
        mat-icon-button
        [attr.aria-label]="'Edit facility users'">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
    <div class="pills-container">
      <div
        class="pill"
        *ngFor="let facilitator of allFacilitators">
        {{ facilitator.email }}
      </div>
    </div>
  </div>
</div>
